<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
      <ion-title>
        Limite de Avaliações
      </ion-title>
      <ion-buttons slot="end">
        <ion-button color="light" (click)="dismiss()" mode="ios">
          <ion-icon class="bp-close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  
  <ion-content class="content" [formGroup]="formGroup">
    <ion-item lines="none">
      <ion-label class="ion-text-left ion-text-wrap">
        <h2 class="ion-text-center">
          Defina o limite de avaliações que um avaliador pode ter pendente.
        </h2>
      </ion-label>
    </ion-item>
    <ion-row class="margin-10">
      <ion-col size="12" size-md="12" class="ion-align-self-center">
        <ion-item>
          <ion-label position="stacked">
            Maximo de Avaliações
          </ion-label>
            <ion-input
                type="number"
                formControlName="maxReviews"
                color="primary"
                placeholder="Maximo de Avaliações"
            ></ion-input>
          
        </ion-item>
      </ion-col>
  
      <ion-col size="12" size-md="12" class="ion-align-self-center">
        <ion-item>
          <ion-label position="stacked">
            Definir o prazo que o gestor terá para substituir o avaliador:
          </ion-label>
          <ion-select
            placeholder="Select"
            formControlName="evaluationTimespanInHours"
            color="primary"
          >
            <ion-select-option
              value="24"
            >
              24 Horas
            </ion-select-option>
            <ion-select-option
              value="48"
            >
              48 Horas
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>

      <ion-col size="12" size-md="12" class="ion-align-self-center">
        <div style="display: flex;justify-content: space-around;gap: 10px;">
            <ion-button 
                class="btn-save"
                fill="outline"
                mode="ios" 
                color="danger" (click)="dismiss()"
                style="min-width: 100px;"
                >
                {{ "generic.cancel" | translate }}
            </ion-button>
            <ion-button
                class="btn-save"
                mode="ios"
                [color]="'secondary'"
                (click)="save()"
                style="min-width: 100px;"
                >
                {{ "generic.save" | translate }}
            </ion-button>
        </div>
        
      </ion-col>
    </ion-row>
  </ion-content>
  